<template>
    <card>
        <div v-for="offset in  Math.ceil(dataList.length/col)" :key="offset">
            <row>
                <!--  //利用js list取指定元素 指定元素 坐标就是第几行的第一个 第一行第一个就是0 偏移量.(0, 4)-->
                <Col :span="24/col" v-for="(item,index) in (dataList.slice((offset-1)*col, (offset-1)*col+col))"
                     :key="index" class="k">
                    <Button class="news-content" type="primary"  style="margin:10%;padding:10% 30% 30% 30%;"
                            @click="pathBodySymptoms(item.id_)">
                        {{ item.name }}
                    </Button>
                </Col>
            </row>
        </div>
    </card>
</template>

<script>
    export default {
        data() {
            return {
                //每行元素基准 limit 24整除这个参数 就可以自适应屏幕多少列了
                col: 6,
                dataList: [],
            };
        },
        created() {
            localStorage.setItem("selectedList", '0');
            this.getBodyPartsList();
        }, methods: {
            getBodyPartsList() {
                this.abHttpUtil
                    .post("/form/formCustSql/view/list_bodyParts", {
                        curPage: 1,
                        pageSize: 100,
                        params: "{}",
                    })
                    .then(
                        (result) => {
                            this.dataList = result.data.list;
                            console.log(this.dataList)
                        },
                        function (status) {
                            if (status == !0) {
                                this.$Message.error("加载失败！" + status);
                            }
                        }
                    );
            },
            pathBodySymptoms(id_) {
                this.$router.push({
                    path: "/BodySymptoms",
                    query: {id_: id_},
                });
            },
        },
    }
</script>

<style scoped>
    .news_container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .news-content {
        font-size: 30px;
    }

    .k {
        display: flex;
        justify-content: center;
        align-content: center;
    }
</style>
